"use client";

import { trimVideo } from "mediatools";
import { ClipOptionsForm, type TimeRange } from "./forms";
import type { MediaOperation } from "./types";
import { toVideoResult } from "./video";

export const trimVideoOperation: MediaOperation<TimeRange> = {
  id: "trim-video",
  group: "video",
  inputKinds: ["video"],
  outputKind: "video",
  showSourcePreview: true,
  defaultOptions: { start: 0, end: 0 },
  OptionsForm: ClipOptionsForm,
  run: async (ctx, options) => {
    if (!ctx.file) throw new Error("No file selected.");
    const trimmed = await trimVideo(ctx.file, {
      start: options.start,
      end: options.end,
      ...(ctx.onProgress ? { onProgress: ctx.onProgress } : {}),
    });
    return toVideoResult(trimmed, ctx.file.name, "trimmed");
  },
};
